const TranspaisDateType = {
  departure: 'Salida',
  returning: 'Retorno',
}

export default TranspaisDateType